module.exports = __webpack_public_path__ + "img/31_26.1e66de49.png";